export const links = {
  // eslint-disable-next-line max-len
  mobile: "https://v.vfgte.com/0d22ca1d-1054-49b6-b8ff-22ab45bfa3ba?subID1=VGIL_999531125_REDG_SIDR&affiliateID=108124&source=TS507-999531125&subID2=PUB_VGIL&Location_Alias=livecircle",
  desktop: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244530",
};
